import imageAlertTypeJournalized from './images/incidentAlertTypeJournalized.png'
import { Form, OverlayTrigger, Popover } from 'react-bootstrap'
import ReactMarkdown from "react-markdown";
import './IncidentItemAlerts.scss'
import IEntityIncident from '../../../../../common/interfaces/entityIncident/IEntityIncident'
import ICustomer from '../../../../../common/interfaces/customer/ICustomer'
import IIncidentAlert from '../../../../../common/interfaces/entityIncident/IIncidentAlert'
import ICustomerAlert from '../../../../../common/interfaces/customer/ICustomerAlert'
import React from 'react';

type ComponentProps = {
  customer: ICustomer
  entityIncident: IEntityIncident
}


const IncidentItemAlerts = (props:ComponentProps) => {

  const entityIncident = props.entityIncident
  const entityIncidentID:string = (entityIncident.entity.entityType + '-' + entityIncident.entity.entityID + '-' + entityIncident.incident.name)

  const getAlertSpecification = (customer:ICustomer, alert:IIncidentAlert) => {
    if (alert.metadata && alert.metadata['entityType'])
    {
      const entityType:string = alert.metadata['entityType']
      const alertSpecification:ICustomerAlert|null|undefined = customer.sense.alerts.find(item => 
        item.type == alert.type &&
        item.registry == alert.registry &&
        item.entityType == entityType)
      return alertSpecification
    }
    else
      return null
  }

  const resolveAlertTemplateMetadata = (alert:IIncidentAlert, template:string) => {
    if (alert.metadata && alert.metadata['entityType'])
    {
      let resultValue:string = template
      for (let metadataKey in alert.metadata) {
        let metadataValue = alert.metadata[metadataKey]
        resultValue = resultValue.replaceAll('{' + metadataKey + '}', metadataValue)
      }
      return resultValue
    }
  }

function LinkRenderer(props:any) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  );
}

  const renderIncidentItemAlerts:any = () => (
    <Popover id={'incident-item-alerts-popover-' + entityIncidentID}>
      <Popover.Header className='incident-item-alerts-popover-header'>Opmærksomhedspunkter ({props.entityIncident.incident.alerts?.length} stk.)</Popover.Header>
      <Popover.Body className='incident-item-alerts-popover-body'>
          {
            props.entityIncident.incident.alerts &&
            props.entityIncident.incident.alerts.map((alert:IIncidentAlert, index:number) => {
              let alertSpecification = getAlertSpecification(props.customer, alert)
              return (
                <React.Fragment key={entityIncidentID +'-' + index}>
                  {
                    alertSpecification &&
                    <div className='alert-item'> 
                      <div className='alert-item-type alert-item-cell'>
                        {
                          alert.type == 'Journalized' && <img className='alert-item-type-icon' title='Journaliseret' alt='' src={imageAlertTypeJournalized} />
                        }  
                      </div>
                      <div className='alert-item-information alert-item-cell'>
                        <div className='alert-item-information-headline'>
                          {
                            alert.reference?.name
                          }
                        </div>
                        <div className='alert-item-information-content'>
                          <ReactMarkdown
                            components={{ a: LinkRenderer }}>
                              {
                              resolveAlertTemplateMetadata(alert, alertSpecification.displayTemplate)
                              }
                          </ReactMarkdown>
                        </div>        
                      </div>
                    </div>
                  }
                  </React.Fragment>
              )
            })
          }
      </Popover.Body>
    </Popover>
  )


  const hidePopover = (popoverID: string) => {
    const popover = document.getElementById(popoverID)
    popover?.style.setProperty('display', 'none')
  }

  return (   
    <> 
      <OverlayTrigger trigger={['click']} rootClose={true} placement='auto' overlay={renderIncidentItemAlerts()}>
        <div>
          {props.entityIncident.incident.alerts?.length}
        </div>
      </OverlayTrigger>    
    </>
  )
}

export default IncidentItemAlerts
